/* ═══════════════════════════════════════════
   GLASHES — Scroll Reveal Animations
   IntersectionObserver-based animations
   ═══════════════════════════════════════════ */

(function() {
  'use strict';

  // Scroll Reveal with IntersectionObserver
  function initScrollReveal() {
    var elements = document.querySelectorAll('.glashes-reveal');
    if (!elements.length) return;

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed');
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      });

      elements.forEach(function(el) {
        observer.observe(el);
      });
    } else {
      // Fallback: show all immediately
      elements.forEach(function(el) {
        el.classList.add('revealed');
      });
    }
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollReveal);
  } else {
    initScrollReveal();
  }

  // Re-init after Shopify section renders (theme editor)
  document.addEventListener('shopify:section:load', function() {
    setTimeout(initScrollReveal, 100);
  });
})();
